import { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { UseI18n } from '../../../../common/hooks/useI18n'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import TextEllipsis from '../../../../common/textEllipsis'
import { formatText } from '../../../../helpers/value'
import { AlertProfile } from '../../../savedPortfolios/portfoliosOverview/components/AlertProfile'

export const CustomTdAlert = ({ data, rowId, colId, isDetail }) => {
  const [isShowAlert, setIsShowAlert] = useState(false)

  const isNotSet = !!data?.value
  const text = UseI18n(data?.label)
  const locale = useSelector((state) => state.i18n.locale)

  const textShow = useMemo(
    () => (data?.isI18n ? text : formatText(data?.label)),
    [locale, data],
  )

  return (
    <>
      <div
        onClick={(e) => {
          setIsShowAlert(!isShowAlert)
          e.stopPropagation()
        }}
        className="dFlex alignItemsCenter"
        style={{ maxWidth: 250 }}
      >
        <Element
          className="dFlex alignItemsCenter justifyContentBetween gap1 w100"
          style={{
            backgroundColor: isNotSet ? '#E5F2FF' : '#D5D5D5',
            border: 'none',
            color: isNotSet ? '#2C73E8' : '#3A414B',
            padding: '0 12px',
            borderRadius: '2px',
            minWidth: 130,
          }}
        >
          <TextEllipsis text={textShow} />
          &nbsp;
          <Icon className="icon-caret-bottom" style={{ fontSize: 8 }} />
        </Element>
      </div>
      {isShowAlert && (
        <AlertProfile
          data={data}
          isShow={isShowAlert}
          setShow={setIsShowAlert}
          rowId={rowId}
          colId={colId}
          isDetail={isDetail}
        />
      )}
    </>
  )
}
